import {useTranslation} from 'react-i18next';

import {
  NextStepRegisterContainer,
  NextStepTitle,
  SignUpSuggestionModalContent,
  StyledButton,
} from './styled';

type Props = {
  onKeepEnteringDataManually: () => void;
  onSignUp: () => void;
};
function SignUpSuggestionModal({onKeepEnteringDataManually, onSignUp}: Props) {
  const {t} = useTranslation();
  return (
    <NextStepRegisterContainer className="chekin-sign-up-suggestion-modal__content">
      <NextStepTitle className="chekin-sign-up-suggestion-modal__title">
        {t('speed_up_your_check_ins')}
      </NextStepTitle>
      <SignUpSuggestionModalContent className="chekin-sign-up-suggestion-modal__description">
        {t('speed_up_your_check_ins_description')}
      </SignUpSuggestionModalContent>
      <StyledButton onClick={onSignUp} variant="primary">
        {t('sign_up')}
      </StyledButton>
      <StyledButton onClick={onKeepEnteringDataManually} variant="link">
        {t('keep_entering_data_manually')}
      </StyledButton>
    </NextStepRegisterContainer>
  );
}

export {SignUpSuggestionModal};
